
const verifyPassword = function () {
    let formData = new FormData($('#passwordForm')[0]);
    formData.append('cid', cid);
    $.ajax({
        url: '/site/verify-community-password',
        data: formData,
        processData: false,
        contentType: false,
        type: 'post'
    }).done(function (data) {
        $('#access_key_submit').prop('disabled', false);
        openAlert(data.message, data.success ? 'success' : 'error').then(() => window.location.reload());
    }).fail(function () {
        $('#access_key_submit').prop('disabled', false);
        window.openAlert(getCommonError(), 'error');
    });
};

const updatePhone = function () {
    let formData = new FormData($('#phoneForm')[0]);
    formData.append('cid', cid);
    $.ajax({
        url: '/site/users/set-phone',
        data: formData,
        processData: false,
        contentType: false,
        type: 'post'
    }).done(function (data) {
        if (data.success) {
            openAlert(data.message, 'success').then(() => window.location.reload());
        }
    }).fail(function () {
        window.openAlert(getCommonError(), 'error');
    });
}

$('document').ready(function () {
    if ($('.community-approval-content').length > 0) {
        $('#access_key_submit').click(function (e) {
            e.preventDefault();
            $('#access_denied').addClass('hidden');
            if ($('#access_key_input').val()) {
                $('#access_key_submit').prop('disabled', true);
                verifyPassword();
            }
        });

        $('#phone_submit').click(function (e) {
            e.preventDefault();
            let input = $('input[name="phone"]');
            if (input.length && input.val() && input.val().match(/^\d+$/)) {
                updatePhone();
            }
        })

        $(document).on('keypress', function (e) {
            if (e.which === 13) {
                e.preventDefault();
                if ($('#access_key_submit').length) {
                    $('#access_key_submit').trigger('click');
                }
                if ($('#phone_submit').length) {
                    $('#phone_submit').trigger('click');
                }
            }
        })
    }
})
